import { useMutation, useQueryClient } from '@tanstack/react-query';
import { batchApprovePots } from '../api/potsApi';

interface ApprovePotParams {
  potPeriodId: string;
  potId: string;
}

/**
 * Mutation hook for approving a single pot.
 * Wraps the batch approve API for single pot approval.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useApprovePot() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ potPeriodId, potId }: ApprovePotParams) => {
      return await batchApprovePots({
        potPeriodId,
        potIds: [potId],
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pots'] });
      queryClient.invalidateQueries({ queryKey: ['potDetails'] });
      queryClient.invalidateQueries({ queryKey: ['payments'] });
    },
  });
}
